import type { SearchCategory } from '@/app/_components/SearchBar/constants';
import { DEFAULT_FESTIVAL_RADIUS_METER } from '@/constants/festival';

export const PAGE_SIZE = 10;
export const PREVIEW_SIZE = 5;

//* 혜택 탭 서버 프리페치와 쿼리 키가 같아야 이동 직후 스켈레톤 없이 그려진다.
export const getLocalMarketSearchQuery = (keyword: string, page: number) => ({
  query: { searchKeyword: keyword, page, size: PAGE_SIZE },
});

export const EMPTY_SEARCH_RESULT_MESSAGE = '검색 결과가 없습니다.';
export const EMPTY_AI_SUMMARY_MESSAGE = '요약 정보가 아직 준비되지 않았어요.';

export interface FilterOption<T extends string | number> {
  value: T;
  label: string;
}

/** 동네축제 반경 필터 옵션 (지역 선택 시 노출) — 첫 옵션이 기본값 */
export const FESTIVAL_RADIUS_OPTIONS: FilterOption<number>[] = [
  DEFAULT_FESTIVAL_RADIUS_METER,
  50_000,
  100_000,
].map((radiusMeter) => ({
  value: radiusMeter,
  label: `${radiusMeter / 1_000}km 이내`,
}));

/** 동네축제 월 필터 옵션 (해당 월에 진행되는 축제만 조회, 미선택 시 전체) */
export const FESTIVAL_MONTH_OPTIONS: FilterOption<number>[] = Array.from(
  { length: 12 },
  (_, index) => ({ value: index + 1, label: `${index + 1}월` }),
);

/**
 * 카테고리별 검색바 최대 폭 (xl 이상).
 * = leftAside + gap + main + gap + rightAside, DesktopPageShell 컬럼 합과 일치.
 *  - filter aside w-202, 광고 aside w-300, gap-24
 *  - main 폭: 좌측 필터 있으면 rail w-[600px], 좌측 없으면 wide(max 750px)
 *  - filter + 광고: 202 + 24 + 600 + 24 + 300 = 1150
 *  - 광고 only(좌측 없음 → main 750): 750 + 24 + 300 = 1074
 *  - filter only(policy·hometown-news): 202 + 24 + 600 = 826
 */
export const SECTION_HEADER_MAX_W: Record<SearchCategory, string> = {
  all: 'xl:max-w-[1074px]',
  policy: 'xl:max-w-[826px]',
  'policy-info': 'xl:max-w-[1150px]',
  'hometown-news': 'xl:max-w-[826px]',
  festival: 'xl:max-w-[1150px]',
  gifts: 'xl:max-w-[1150px]',
  'hometown-business': 'xl:max-w-[1150px]',
  welmarket: 'xl:max-w-[1074px]',
};
